import mainCaller from './mainCaller';

// 회원 그룹 (지점 내 자유 그룹) — backend: /admin/api/v1/member-groups

export async function getMemberGroups(token, branchId) {
  return await mainCaller(`admin/api/v1/member-groups?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 상세용. 그 지점 안에서 이 회원이 속한 그룹만 돌려준다.
export async function getMemberGroupsOfMember(token, memberId, branchId) {
  return await mainCaller(
    `admin/api/v1/member-groups/by-member/${memberId}?branchId=${branchId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

export async function createMemberGroup(token, body) {
  return await mainCaller(`admin/api/v1/member-groups`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateMemberGroup(token, groupId, body) {
  return await mainCaller(`admin/api/v1/member-groups/${groupId}`, 'PUT', body, {
    Authorization: `Bearer ${token}`,
  });
}

export async function deleteMemberGroup(token, groupId) {
  return await mainCaller(`admin/api/v1/member-groups/${groupId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getMemberGroupMembers(token, groupId) {
  return await mainCaller(`admin/api/v1/member-groups/${groupId}/members`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 기소속·미존재 회원은 백엔드가 에러 없이 skip하고 {addedCount, skippedCount}를 돌려준다.
export async function addMemberGroupMembers(token, groupId, memberIds) {
  return await mainCaller(`admin/api/v1/member-groups/${groupId}/members`, 'POST', { memberIds }, {
    Authorization: `Bearer ${token}`,
  });
}

export async function removeMemberGroupMembers(token, groupId, memberIds) {
  return await mainCaller(`admin/api/v1/member-groups/${groupId}/members`, 'DELETE', { memberIds }, {
    Authorization: `Bearer ${token}`,
  });
}

// 그룹 회원들의 기간 내 출결(예약/출석/결석) 내역
export async function getMemberGroupAttendance(token, groupId, startDate, endDate) {
  return await mainCaller(
    `admin/api/v1/member-groups/${groupId}/attendance?startDate=${startDate}&endDate=${endDate}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

// 그룹 회원들의 기간 내 방문(체크인 입장) 내역. 수업 예약이 없는 이용권 입장까지 포함한다.
// 출석부 — 그룹 회원이 지점에 들어온 날. 예약 출석과 합쳐야 '방문'이 된다(하루 1회).
export async function getMemberGroupAttendDays(token, groupId, startDate, endDate) {
  return await mainCaller(
    `admin/api/v1/member-groups/${groupId}/attend-days?startDate=${startDate}&endDate=${endDate}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

export async function getMemberGroupVisits(token, groupId, startDate, endDate) {
  return await mainCaller(
    `admin/api/v1/member-groups/${groupId}/visits?startDate=${startDate}&endDate=${endDate}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}
